import cx from 'classnames'
import { useMemo } from 'react'
import CustomPhotosHeaderSlidingContent, {
  PhotoWithOrientation,
} from './CustomPhotosHeaderSlidingContent'
import staticHeaderCutoutRegular from '../assets/landing/header-cutout-regular.png'
import staticHeaderRegular from '../assets/landing/header-static-regular.png'
import { CuratedPhotoForPhotoProducts, FrameConfiguration } from '../types'

const REGULAR_WIDTH = 780
const REGULAR_HEIGHT = 802

const DPF_JP_FRAMES_REGULAR: FrameConfiguration = {
  width: REGULAR_WIDTH,
  height: REGULAR_HEIGHT,
  requiredPhotos: 6,
  frames: [
    {
      left: (200 / REGULAR_WIDTH) * 100,
      top: (376 / REGULAR_HEIGHT) * 100,
      width: (374 / REGULAR_WIDTH) * 100,
      height: (228 / REGULAR_HEIGHT) * 100,
      rotate: 0,
    },
  ],
}

export default function CuratedPhotosHeader({
  curatedPhotos,
  isUsingFallback,
  frameOffsets,
  cutoutImageClassName,
}: {
  curatedPhotos: CuratedPhotoForPhotoProducts[]
  isUsingFallback: boolean
  frameOffsets?: Array<{
    left: number
    top: number
    scale?: number
    rotate?: number
    zIndex?: number
  }>
  cutoutImageClassName?: string
}) {
  const photos: PhotoWithOrientation[] = useMemo(
    () =>
      isUsingFallback
        ? []
        : curatedPhotos.map(photo => ({
            url: photo.croppedUrl,
            isLandscape:
              !!photo.imageWidth && !!photo.imageHeight && photo.imageWidth > photo.imageHeight,
          })),
    [isUsingFallback, curatedPhotos],
  )

  if (photos.length < DPF_JP_FRAMES_REGULAR.requiredPhotos) {
    return (
      <img
        src={staticHeaderRegular}
        className={cx('w-full h-full object-cover', cutoutImageClassName)}
        loading='eager'
        width={REGULAR_WIDTH}
        height={REGULAR_HEIGHT}
        style={{ aspectRatio: `${REGULAR_WIDTH}/${REGULAR_HEIGHT}` }}
        alt='Header image'
      />
    )
  }

  return (
    <CustomPhotosHeaderSlidingContent
      photos={photos}
      frameOffsets={frameOffsets}
      cutoutImageClassName={cutoutImageClassName}
      cutoutImage={staticHeaderCutoutRegular}
      frameConfiguration={DPF_JP_FRAMES_REGULAR}
    />
  )
}
